const CACHE = {};

/**
 * Returns a string meant to be used as a variant for an attribute editor or setter.
 * getVariant( 'table', 'string', 'editor' ) will result in the string 
 * 'attributeTableStringEditor|attributeTableEditor|attributeStringEditor|attributeEditor'
 * @param {string} usage the usage of the variant. normally 'table' or 'detail'
 * @param {string} type normally the type of the attribute, like 'String', 'Int'
 * @param {string} purpose normally 'Editor' or 'Viewer'
 */
function getVariant(usage, type, purpose) {
  const u = usage || '';
  const t = type || '';
  const p = purpose || '';
  let v1 = CACHE[u];
  if (v1 === undefined) {
    v1 = {
      [t]: {}
    };
    CACHE[u] = v1;
  }
  let v2 = v1[t];
  if (v2 === undefined) {
    v2 = {};
    v1[t] = v2;
  }
  let v3 = v2[p];
  if (v3 === undefined) {
    const uUc = u.length > 0 ? `${u[0].toUpperCase()}${u.substring(1)}` : '';
    const tUc = t.length > 0 ? `${t[0].toUpperCase()}${t.substring(1)}` : '';
    const pUc = p.length > 0 ? `${p[0].toUpperCase()}${p.substring(1)}` : '';
    const arr = [...new Set([`attribute${uUc}${tUc}${pUc}`, `attribute${uUc}${pUc}`, `attribute${tUc}${pUc}`, `attribute${pUc}`])];
    v3 = arr.join('|');
    v2[p] = v3;
  }
  return v3;
}
export default {
  getVariant
};